<template>
  <div>
    <StatisticArticleTableDialog ref="statisticArticleDialog"></StatisticArticleTableDialog>
    <v-card>
      <p class="pt-3 pl-3 title">Statistic Articles</p>
      <v-data-table
        :headers="headers"
        :items="countryObjectIntoArray"
        class="elevation-1"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon
            medium
            @click="$refs.statisticArticleDialog.openDialog(item)"
            color="error"
          >
            fas fa-book
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
      <!-- {{filterArticleData.countries.thisMonth}}
      <v-divider></v-divider>
      <v-divider></v-divider>
       -->
      <!-- <pre>{{articleData}}</pre> -->
  </div>
</template>

<script>
// Import funcitons from store.js (vuex)
import { mapActions } from "vuex";
import StatisticArticleTableDialog from "@/pages/admin/components/statistic/articles/dialog/statisticArticleTableDialog"
export default {
  components:{
    StatisticArticleTableDialog
  },
  data(){
    return{
      articleData: [],
       headers:[
        { text: 'Country', value: 'countries', align: 'center' },
        { text: 'Amount of Articles', value: 'TotalArticles', align: 'center' },
        { text: 'New Articles (24h)', value: 'NewArticlesDay', align: 'center' },
        { text: 'New Articles (week)', value: 'NewArticlesWeek', align: 'center' },
        { text: 'New Articles (month)', value: 'NewArticlesMonth', align: 'center' },
        { text: 'New Articles (year)', value: 'NewArticlesYear', align: 'center' },
        // { text: 'Comments enabled', value: 'ArticlesWithCommentsEnabled', align: 'center' },
        { text: 'User Development', value: 'actions', sortable: false, align: 'center' }
      ]
    }
  },
  methods:{
    // Import these functions from store.js
    ...mapActions([
      "GET_ALL_ARTICLES"
    ]),
  
    getAllArticleData(){
      this.GET_ALL_ARTICLES().then(response => {
        response = response.map(el => {
          return {
            ...el,
           CreatedDays: this.$moment().diff(this.$moment(el.created), 'days'),
          }
        })
        this.articleData = response;
        // alert(this.articleData.length + ' ' + 'Articles found, please wait while it is loading in')
      })
    }
  },
  computed:{
    // Filter and get the Article data served as we want it.
    filterArticleData(){
      let thisDay = this.articleData.filter(article => article.CreatedDays === 0).length;
      let thisWeek = this.articleData.filter(article => article.CreatedDays < 7).length;
      let thisMonth = this.articleData.filter(article => article.CreatedDays < 31).length;
      let thisYear = this.articleData.filter(article => article.CreatedDays < 365).length;
      let seeAllDataYear = this.articleData.filter(article => article.CreatedDays < 365);
      // let isCommented = this.articleData.filter(article => article.iscommentsenabled).length;
      let countries = {};
      // Specific filter, to see country specific data
      this.articleData.map(article => article.usercountry).forEach(country => {
        if (!countries.hasOwnProperty(country)) {
          /*
            1. Create a variable, that one will use in the function below.
            2. Choose what to filter through.     (this.articleData).
            3. First filter, one get the country, to sort by that.
            4. Second filter, one filter on what one wish to sort out
          */
          let thisDay = this.articleData.filter(article => article.usercountry === country).filter(article => article.CreatedDays === 0).length;
          let thisWeek = this.articleData.filter(article => article.usercountry === country).filter(article => article.CreatedDays < 7).length;
          let thisMonth = this.articleData.filter(article => article.usercountry === country).filter(article => article.CreatedDays < 31).length;
          let thisYear = this.articleData.filter(article => article.usercountry === country).filter(article => article.CreatedDays < 365).length;
          let total = this.articleData.filter(article => article.usercountry === country).length;
          let totalarticleData = this.articleData.filter(article => article.usercountry === country);
          // Total of articles that have comments enabled/disabled
          let articlesWithComment = this.articleData.filter(article => article.usercountry === country).filter(article => article.iscommentsenabled === 1).length;
          let articlesWithoutComment = this.articleData.filter(article => article.usercountry === country).filter(article => article.iscommentsenabled === 0).length;
          // Amount of comments made on the article
          let totalArticleComments = this.articleData.filter(article => article.usercountry === country).filter(article => article.articlecomments).length;
          // Total of articles that are published / not published
          let articleThatArePublished = this.articleData.filter(article => article.usercountry === country).filter(article => article.ispublished === 1).length;
          let articleThatAreNotPublished = this.articleData.filter(article => article.usercountry === country).filter(article => article.ispublished === 0).length;
          // Type of the article created
          let articleTypeRSS = this.articleData.filter(article => article.usercountry === country).filter(article => article.type === 'rss_article').length;
          let articleTypeArticle = this.articleData.filter(article => article.usercountry === country).filter(article => article.type === 'article').length;
          // Gender of the one creating the article
          let genderMaleCreateArticle = this.articleData.filter(article => article.usercountry === country).filter(article => article.usersex === 'M').length;
          let genderFemaleCreateArticle = this.articleData.filter(article => article.usercountry === country).filter(article => article.usersex === 'F').length;
          // Amount of articles that have been reported
          let reportedArticles = this.articleData.filter(article => article.usercountry === country).filter(article => article.articlereports === 1).length;

          // Where we put all these variables into countries,  which again goes into the return object below
          countries[country] = {thisDay, thisWeek, thisMonth, thisYear, total, totalarticleData, totalArticleComments, articlesWithComment,articlesWithoutComment, articleTypeRSS, articleTypeArticle, genderMaleCreateArticle, genderFemaleCreateArticle, reportedArticles, articleThatArePublished, articleThatAreNotPublished }
        }
      })
      return {thisDay, thisWeek, thisMonth, thisYear, seeAllDataYear, countries};
    },
    
    // These are also the keys that will be displayed within the dialog. Through item
    countryObjectIntoArray(){
      if (this.filterArticleData.countries ) {
        return Object.keys(this.filterArticleData.countries).map((key, index) => {
          let _return = {
            countries: key,
            TotalArticles: this.filterArticleData.countries[key].total,
            NewArticlesDay:  this.filterArticleData.countries[key].thisDay,
            NewArticlesWeek: this.filterArticleData.countries[key].thisWeek,
            NewArticlesMonth:  this.filterArticleData.countries[key].thisMonth,
            NewArticlesYear:  this.filterArticleData.countries[key].thisYear,
            // ArticleGraph: this.filterArticleData.countries[key].totalarticleData.map(el => this.$moment().diff(this.$moment(el.Created), 'months')).sort((a,b) => {return a < b ? -1 : a > b ? 1 : 0}),
            ArticlesWithCommentsEnabled: this.filterArticleData.countries[key].articlesWithComment,
            ArticlesWithCommentsDisabled: this.filterArticleData.countries[key].articlesWithoutComment,
            TotalArticleComments: this.filterArticleData.countries[key].totalArticleComments,
            ArticleTypeRSS: this.filterArticleData.countries[key].articleTypeRSS,
            ArticleTypeArticle: this.filterArticleData.countries[key].articleTypeArticle,
            ArticlesWrittenByMales: this.filterArticleData.countries[key].genderMaleCreateArticle,
            ArticlesWrittenByFemales: this.filterArticleData.countries[key].genderFemaleCreateArticle,
            ArticlesReported: this.filterArticleData.countries[key].reportedArticles,
            ArticlesThatArePublished: this.filterArticleData.countries[key].articleThatArePublished,
            ArticlesThatAreNotPublished: this.filterArticleData.countries[key].articleThatAreNotPublished
          }
          let ArticleGraph = new Array(12);
          for (var i = 0; i < ArticleGraph.length; i++) {
            ArticleGraph[i] = this.filterArticleData.countries[key].totalarticleData.filter(el => Math.floor(el.CreatedDays / 30) == (ArticleGraph.length - i - 1)).length;
          }
          _return.ArticleGraph = ArticleGraph;
          return _return;
        });
      } else {
        return [];
      }
    },
  },
  // Run this function when page are loaded
  mounted() {
    this.getAllArticleData();
  }
}
</script>